import { render, staticRenderFns } from "./highRiskSupplierList.vue?vue&type=template&id=ed7f282a&scoped=true"
import script from "./highRiskSupplierList.vue?vue&type=script&lang=js"
export * from "./highRiskSupplierList.vue?vue&type=script&lang=js"
import style0 from "./highRiskSupplierList.vue?vue&type=style&index=0&id=ed7f282a&prod&lang=scss&scoped=true"
import style1 from "./highRiskSupplierList.vue?vue&type=style&index=1&id=ed7f282a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7f282a",
  null
  
)

export default component.exports